// SectionCard — DRY: one card shell for stacked page sections
// (session info / attendance / feedback / materials on the tutor
// session detail page), title row carries an icon prefix.
import type { ReactNode } from "react";

interface SectionCardProps {
  title: string;
  icon: ReactNode;
  children: ReactNode;
}

export default function SectionCard({ title, icon, children }: SectionCardProps) {
  return (
    <section
      className="bg-white rounded-xl p-5 border border-gray-200"
      style={{ borderWidth: "0.5px" }}
    >
      <h2 className="flex items-center gap-2 text-sm font-medium text-dm-navy mb-4">
        <span className="text-dm-slate">{icon}</span>
        {title}
      </h2>
      {children}
    </section>
  );
}
